export const { MODE, VITE_API_URL, VITE_SOCKET_URL } = import.meta.env;
export const IS_DEV = MODE === 'development';
export const IS_PROD = MODE === 'production';
export const API_URL = VITE_API_URL || 'http://localhost:3000';
export const SOCKET_URL = VITE_SOCKET_URL || 'ws://localhost:3000';
